import { render, staticRenderFns } from "./tui2.vue?vue&type=template&id=580a3fb0&scoped=true&"
import script from "./tui2.vue?vue&type=script&lang=js&"
export * from "./tui2.vue?vue&type=script&lang=js&"
import style0 from "./tui2.vue?vue&type=style&index=0&id=580a3fb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a3fb0",
  null
  
)

export default component.exports